/* import __COLOCATED_TEMPLATE__ from './fly-power-select.hbs.js'; */
var _dec, _dec2, _dec3, _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@glimmer/component';
import EmObject, { get, getProperties, action, computed } from '@ember/object';
import { isNone } from '@ember/utils';
import itemProperty from '@customerio/fly-components/utils/item-property';
import { A } from '@ember/array';
import { indexOfOption } from 'ember-power-select/utils/group-utils';
import { stringIncludes } from '@customerio/fly-components/utils/string';
import { isPowerSelectGroup, flattenOptions, filterOptions } from '@customerio/fly-components/utils/power-select';
import { tracked } from '@glimmer/tracking';
import FlyPowerSelectToggle from '@customerio/fly-components/components/fly-power-select/toggle';
import FlyPowerSelectSelectedItem from '@customerio/fly-components/components/fly-power-select/selected-item';
import FlyPowerSelectList from '@customerio/fly-components/components/fly-power-select/list';
import { ensureSafeComponent } from '@embroider/util';
/**
  @public
  @class FlyPowerSelect
 **/
let FlyPowerSelect = (_dec = computed('args.options.[]'), _dec2 = computed('args.options.[]', 'args.{selectedItem,selectedValue,valueProperty}'), _dec3 = computed('args.{secondaryLabelProperty,itemWidth,iconProperty,iconFillProperty,matchContentWidth,onScrollEnd,onScrollEndThreshold,hasError}', 'size', 'labelProperty', 'valueProperty', 'matchContentWidth'), (_class = class FlyPowerSelect extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "highlightedOption", _descriptor, this);
  }
  get labelProperty() {
    return this.args.labelProperty ?? 'label';
  }
  get valueProperty() {
    return this.args.valueProperty ?? 'value';
  }
  get matchContentWidth() {
    return this.args.matchContentWidth ?? true;
  }
  get size() {
    return this.args.size ?? 'normal';
  }
  get noMatchesMessage() {
    return this.args.noMatchesMessage ?? "Oops! There's nothing to choose from…";
  }
  get placeholder() {
    return this.args.placeholder ?? 'Search…';
  }
  get renderInPlace() {
    return this.args.renderInPlace ?? true;
  }
  get matcher() {
    return this.args.matcher ?? null;
  }
  get searchField() {
    // If there's no searchField provided, it makes sense to search for what's
    // shown, i.e. the label property.
    return this.args.searchField ?? this.labelProperty;
  }
  get verticalPosition() {
    return this.args.verticalPosition ?? 'below';
  }
  get horizontalPosition() {
    return this.args.horizontalPosition ?? 'auto';
  }
  get optionsComponent() {
    return ensureSafeComponent(this.args.optionsComponent ?? FlyPowerSelectList, this);
  }
  get selectedItemComponent() {
    return ensureSafeComponent(this.args.selectedItemComponent ?? FlyPowerSelectSelectedItem, this);
  }
  get triggerComponent() {
    return ensureSafeComponent(this.args.triggerComponent ?? FlyPowerSelectToggle, this);
  }
  get matchTriggerWidth() {
    return this.args.matchTriggerWidth ?? true;
  }

  /**
    An EmberArray instance of the options array. Needed to support usage with DS.PromiseArray.
     @property optionsEmArray
    @type EmberArray
    @private
   */
  get optionsEmArray() {
    return A(this.args.options);
  }
  get selectedItem() {
    if (this.args.selectedItem) {
      return this.args.selectedItem;
    }
    let {
      args: {
        selectedValue
      },
      optionsEmArray,
      valueProperty
    } = this;
    if (isNone(optionsEmArray)) {
      return null;
    }
    if (optionsEmArray.slice().some(opt => isPowerSelectGroup(opt))) {
      optionsEmArray = A(flattenOptions(optionsEmArray));
    }
    return optionsEmArray.find(option => itemProperty(option, valueProperty) === selectedValue);
  }
  get _extra() {
    let extraPropertiesArgs = ['itemWidth', 'showSelectedItemIcon', 'iconProperty', 'iconFillProperty', 'onScrollEnd', 'onScrollEndThreshold', 'secondaryLabelProperty', 'hasError'];
    let extraPropertiesThis = ['labelProperty', 'valueProperty', 'size', 'matchContentWidth'];

    // During the emit phase of typescript, it will complain that `this` is not
    // accessible in this context, and requires a custom type. Further, typing
    // `this` in the getter declaration is also not allowed by the TS compiler.
    // This line is a hack to get around the restrictions during the emit phase.
    /* eslint-disable-next-line @typescript-eslint/no-this-alias */
    let anyThis = this;
    return EmObject.create({
      ...getProperties(anyThis.args, ...extraPropertiesArgs),
      ...getProperties(anyThis, ...extraPropertiesThis),
      ...(anyThis.args.extra || {})
    });
  }
  async _searchWithCreate(term, select) {
    // await to support DS.PromiseArray:
    let options = await this.optionsEmArray;
    if (term.length === 0) {
      return options;
    }
    if (this.args.search) {
      let results = await this.args.search(term, select);
      return this._maybeWithSuggestedValue(term, results);
    }
    return this._maybeWithSuggestedValue(term, this._filter(A(options), term));
  }

  // If there are no results _and_ users can create custom values, we return a
  // custom suggested value based on the search term. Otherwise, just return the
  // results.
  _maybeWithSuggestedValue(term, results) {
    let {
      labelProperty
    } = this;
    if (!this.args.allowCustomValues || results.some(option => (typeof option === 'object' ? option[labelProperty] : option) === term)) {
      return results;
    }
    return [{
      __customvalue__: true,
      value: term,
      label: term
    }, ...results];
  }

  // Filter options based on either a matcher passed in or the default matcher.
  // Options can either be strings or objects. If they are objects, then we look
  // for the `searchField` property.
  _filter(options, searchText) {
    let matcher = this.matcher || this._defaultMatcher;
    let result = filterOptions(options || [], searchText, (option, text) => matcher(typeof option === 'object' ? get(option, this.searchField || '') : option, text));
    this.highlightedOption = result.highlightedOption !== null ? result.options[result.highlightedOption] : null;
    return result.options;
  }
  _defaultMatcher(option, searchTerm) {
    let haystack = (option || '').toString().toLowerCase();
    let needle = (searchTerm || '').toString().toLowerCase();
    if (haystack === needle) {
      return 2;
    }
    return stringIncludes(haystack, needle) ? 1 : -1;
  }

  // Slightly modified version of ember-power-select's scrollTo
  // https://github.com/cibernox/ember-power-select/blob/c18e0d9ea5c0ad9cea8acdca0306e56376a7bb2b/addon/components/power-select.ts#L417
  scrollTo(option, select) {
    if (document == null || option == null) {
      return;
    }
    if (this.args.scrollTo != null) {
      return this.args.scrollTo(option, select);
    }
    let optionsList = document.getElementById(`ember-power-select-options-${select.uniqueId}`);
    if (optionsList == null) {
      return;
    }
    let index = indexOfOption(select.results, option);
    if (index === -1) {
      return;
    }
    // The difference is here. ember-power-select uses .item(index) to get the
    // option element. However, this won't work with a VerticalCollection, since
    // not all options are rendered. Instead, we'll use a direct selector with
    // the data-option-index attribute.
    let optionElement = optionsList.querySelector(`[data-option-index="${index}"]`);
    if (optionElement == null) {
      return;
    }
    let optionTopScroll = optionElement.offsetTop - optionsList.offsetTop;
    let optionBottomScroll = optionTopScroll + optionElement.offsetHeight;
    if (optionBottomScroll > optionsList.offsetHeight + optionsList.scrollTop) {
      optionsList.scrollTop = optionBottomScroll - optionsList.offsetHeight;
    } else if (optionTopScroll < optionsList.scrollTop) {
      optionsList.scrollTop = optionTopScroll;
    }
  }
}, (_applyDecoratedDescriptor(_class.prototype, "optionsEmArray", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "optionsEmArray"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedItem", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "selectedItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_extra", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "_extra"), _class.prototype), _descriptor = _applyDecoratedDescriptor(_class.prototype, "highlightedOption", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "_searchWithCreate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_searchWithCreate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "scrollTo", [action], Object.getOwnPropertyDescriptor(_class.prototype, "scrollTo"), _class.prototype)), _class));
export { FlyPowerSelect as default };